import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormControl, Icon, ListItem, ListItemText } from "@mui/material";

import MDBox from "theme/components/MDBox";
import Multiselect from "multiselect-react-dropdown";
import MDTypography from "components/MDTypography";
import MDButton from "theme/components/MDButton";

function MultiSelectField({ formRef, draftIndex, displayName, fieldRef, options }) {
  const [selectedChoices, setSelectedChoices] = useState(new Set());
  const [ccs, setCCs] = useState(null);
  const [mchoices, setMChoices] = useState([]);

  useEffect(() => {
    if (selectedChoices.size <= 0) {
      setCCs(null);
      return;
    }

    const lls = [];
    selectedChoices.forEach((opt) => {
      lls.push(opt);
    });

    // setCCs(JSON.stringify(lls));
    setCCs(lls.join());
  }, [selectedChoices]);

  useEffect(() => {
    const xArr = [];
    selectedChoices.forEach((item) => {
      options.every((ele) => {
        if (ele.value === item) {
          xArr.push(ele);
          return false;
        }
        return true;
      });
    });
    setMChoices(xArr);
  }, [selectedChoices]);

  const [hasSavedValue, setHasSavedValue] = useState(false);
  const [draftValue, setDraftValue] = useState(null);

  useEffect(() => {
    if (!formRef) return;

    const saved = localStorage.getItem(`draft_${formRef}`);
    if (!saved) return;

    try {
      const parsed = JSON.parse(saved);
      const val = parsed?.[draftIndex].values?.[fieldRef];

      if (val !== undefined && val !== null && val !== "") {
        setDraftValue(val);
        setHasSavedValue(true);
      }
    } catch (e) {
      console.error("Draft parse error", e);
    }
  }, [formRef, fieldRef]);

  return (
    <MDBox mt={0}>
      {hasSavedValue ? (
        <MDBox>
          <ListItem divider>
            <MDBox mr={1}>
              <Icon color="success">check_circle</Icon>
            </MDBox>
            <ListItemText
              primary={
                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                  {displayName}
                </MDTypography>
              }
            />
            <MDButton
              size="small"
              color="warning"
              variant="outlined"
              iconOnly
              onClick={() => {
                try {
                  const key = `draft_${formRef}`;
                  const saved = localStorage.getItem(key);
                  if (!saved) return;

                  const parsed = JSON.parse(saved);

                  if (parsed?.values && fieldRef in parsed.values) {
                    delete parsed.values[fieldRef];
                  }

                  // persist updated draft
                  localStorage.setItem(key, JSON.stringify(parsed));

                  // update UI state
                  setHasSavedValue(false);
                  setDraftValue(null);
                } catch (e) {
                  console.error("Failed to clear draft field", e);
                }
              }}
            >
              <Icon>edit</Icon>
            </MDButton>
          </ListItem>
          <input
            type="hidden"
            id={`dff_${fieldRef}`}
            name={fieldRef}
            value={draftValue}
          />
        </MDBox>
      ) : (
        <MDBox>
          <MDBox ml={0.5}>
            <MDTypography variant="h6" fontSize={14} fontWeight="light">
              {displayName}
            </MDTypography>
          </MDBox>
          <MDBox mt={0.5}>
            <FormControl sx={{ minWidth: 120, width: "100%" }}>
              <Multiselect
                options={options} // Options to display in the dropdown
                selectedValues={mchoices} // Preselected value to persist in dropdown
                onSelect={(selectedList, selectedItem) => {
                  const newSet = new Set(selectedChoices);
                  if (!newSet.has(selectedItem.value)) {
                    newSet.add(selectedItem.value);
                    setSelectedChoices(newSet);
                  }
                }} // Function will trigger on select event
                onRemove={(selectedList, removedItem) => {
                  const newSet = new Set(selectedChoices);
                  if (newSet.has(removedItem.value)) {
                    newSet.delete(removedItem.value);
                    setSelectedChoices(newSet);
                  }
                }} // Function will trigger on remove event
                displayValue="name" // Property name to display in the dropdown options
                showCheckbox={false}
                // placeholder={displayName}
                avoidHighlightFirstOption
                color="primary"
              />
            </FormControl>
            <input
              type="hidden"
              id={`dff_${fieldRef}`}
              name={fieldRef}
              value={ccs}
            />
          </MDBox>
        </MDBox>
      )}
    </MDBox>
  );
}

// Typechecking props of the Transaction
MultiSelectField.propTypes = {
  formRef: PropTypes.string.isRequired,
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

MultiSelectField.defaultProps = {
  options: null,
};
export default MultiSelectField;
